/** @format */

import {isObject} from 'helpers/miscHelpers';

import {ObjectValueType} from '../types';

const isObjectValueGuard = (value: unknown): value is ObjectValueType => {
  if (!isObject(value)) {
    return false;
  }

  const keys = Object.keys(value);

  return (
    keys.length > 0 &&
    keys.every(key => typeof (value as Record<string, unknown>)[key] === 'string')
  );
};

export {isObjectValueGuard};
